import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Box,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import {
  Work as WorkIcon,
  Build as BuildIcon,
  LocalOffer as LocalOfferIcon,
  Event as EventIcon,
  Title as TitleIcon,
  Campaign as CampaignIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import ExploreIcon from "@mui/icons-material/Explore";
import API_BASE_URL from "../config";

const Opportunities = () => {
  const navigate = useNavigate(); // Initialize useNavigate
  const [selectedPlans, setSelectedPlans] = useState({
    Access: [],
    jobs: [],
    services: [],
    offers: [],
    events: [],
    sponsoredAd: [],
    classifieds: [],
  });

  const [adminSettingsData, setAdminSettingsData] = useState(null); // State to hold the latest admin settings data
  const [servicePricing, setServicePricing] = useState({
    Access: [],
    jobs: [],
    services: [],
    offers: [],
    events: [],
    sponsoredAd: [],
    classifieds: [],
  });

  useEffect(() => {
    const fetchAdminSettingsData = async () => {
      try {
        const response = await fetch(
          // `http://localhost:5000/api/admin-settings`
          `${API_BASE_URL}/admin-settings`
        );
        const data = await response.json();

        // Find the configuration with the highest id
        const latestConfig = data.configuration_settings.reduce(
          (latest, current) => {
            return current.id > latest.id ? current : latest;
          },
          data.configuration_settings[0]
        );

        console.log("Latest Admin Settings Data:", latestConfig); // Log the latest configuration
        setAdminSettingsData(latestConfig); // Store the latest configuration in state

        // Dynamically update servicePricing with the data from latestConfig
        setServicePricing({
          Access: [
            {
              plan: "Basic",
              price: latestConfig.access || 199,
              description:
                "To Access all the opportunities across the application and you can apply for 10 opportunities for free. After that, you need to subscribe to this plan to explore all the opportunities.",
            },
          ],
          jobs: [
            {
              plan: "Basic",
              price: latestConfig.job_basic || 499,
              description: "Last priority for visibility",
            },
            {
              plan: "Premium",
              price: latestConfig.job_premium || 999,
              description: "Second preference for 10 days",
            },
            {
              plan: "Advanced",
              price: latestConfig.job_advanced || 1599,
              description: "Exclusive top priority for 1 month",
            },
          ],
          services: [
            {
              plan: "Starter",
              price: latestConfig.services_starter || 599,
              description: "Last priority for visibility",
            },
            {
              plan: "Pro",
              price: latestConfig.services_pro || 999,
              description: "Second preference for 10 days",
            },
            {
              plan: "Enterprise",
              price: latestConfig.services_enterprise || 1599,
              description: "Exclusive top priority for 1 month",
            },
          ],
          offers: [
            {
              plan: "Basic",
              price: latestConfig.offer_basic || 399,
              description: "Last priority for visibility",
            },
            {
              plan: "Premium",
              price: latestConfig.offer_pro || 1499,
              description: "Second preference for 10 days",
            },
            {
              plan: "Advanced",
              price: latestConfig.offer_advanced || 1999,
              description: "Exclusive top priority for 1 month",
            },
          ],
          events: [
            {
              plan: "General",
              price: latestConfig.event_general || 499,
              description: "Last priority for visibility",
            },
            {
              plan: "Premium",
              price: latestConfig.event_premium || 1499,
              description: "Second preference for 10 days",
            },
            {
              plan: "Exclusive",
              price: latestConfig.event_exclusive || 1999,
              description: "Exclusive top priority for 1 month",
            },
          ],
          sponsoredAd: [
            {
              plan: "Basic",
              price: latestConfig.ad_basic || 599,
              description: "Last priority for visibility",
            },
            {
              plan: "Premium",
              price: latestConfig.ad_premium || 1999,
              description: "Second preference for 10 days",
            },
            {
              plan: "Advanced",
              price: latestConfig.ad_advanced || 2499,
              description: "Exclusive top priority for 1 month",
            },
          ],
          classifieds: [
            {
              plan: "Standard",
              price: latestConfig.classifieds_standard || 499,
              description: "Last priority for visibility",
            },
            {
              plan: "Premium",
              price: latestConfig.classifieds_premium || 999,
              description: "Second preference for 10 days",
            },
            {
              plan: "Exclusive",
              price: latestConfig.classifieds_exclusive || 1599,
              description: "Exclusive top priority for 1 month",
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching admin settings data:", error);
      }
        };
    
        fetchAdminSettingsData(); // Fetch data when the component mounts
        }, []); // Empty dependency array to run once when the component mounts
      
        //const handleCheckboxChange = (category, plan) => {
          //setSelectedPlans((prevSelectedPlans) => {
          //const currentPlans = [...prevSelectedPlans[category]];
            //if (currentPlans.includes(plan)) {
              // Uncheck the checkbox by removing the plan
              //const index = currentPlans.indexOf(plan);
              //currentPlans.splice(index, 1);
            //} else {
              // Check the checkbox by adding the plan
              //currentPlans.push(plan);
            //}
      
            // Update the state for the selected plans in that category
            //return { ...prevSelectedPlans, [category]: currentPlans };
          //});
        //};
        const handleCheckboxChange = (category, plan) => {
        setSelectedPlans((prevSelectedPlans) => {
          return { ...prevSelectedPlans, [category]: [plan] }; // Set only the selected plan
        });
      };


  const getSelectedPlansForCategory = (category) => {
    return servicePricing[category].filter((plan) =>
      selectedPlans[category].includes(plan.plan)
    );
  };

  const handleSubscribe = (item) => {
    const selectedPlansForCategory = getSelectedPlansForCategory(item.category);
    navigate("/subscription", {
      state: {
        opportunityTitle: item.label,
        selectedPlans: selectedPlansForCategory,
      },
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: 3,
        mb: 4,
      }}
    >
      <Grid container spacing={3} justifyContent="center">
        {[
          {
            label: "Access",
            category: "Access",
            icon: <ExploreIcon sx={{ color: "#42326e" }} />,
            pricing: servicePricing.Access,
          },
          {
            label: "Jobs",
            category: "jobs",
            icon: <WorkIcon sx={{ color: "#42326e" }} />,
            pricing: servicePricing.jobs,
          },
          {
            label: "Services",
            category: "services",
            icon: <BuildIcon sx={{ color: "#42326e" }} />,
            pricing: servicePricing.services,
          },
          {
            label: "Offers",
            category: "offers",
            icon: <LocalOfferIcon sx={{ color: "#42326e" }} />,
            pricing: servicePricing.offers,
          },
          {
            label: "Events",
            category: "events",
            icon: <EventIcon sx={{ color: "#42326e" }} />,
            pricing: servicePricing.events,
          },
          {
            label: "Sponsored Ad",
            category: "sponsoredAd",
            icon: <TitleIcon sx={{ color: "#42326e" }} />,
            pricing: servicePricing.sponsoredAd,
          },
          {
            label: "Classifieds",
            category: "classifieds",
            icon: <CampaignIcon sx={{ color: "#42326e" }} />,
            pricing: servicePricing.classifieds,
          },
        ].map((item, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card sx={{ p: 2, textAlign: "center", boxShadow: 3 }}>
              <CardContent>
                <Box sx={{ fontSize: 50, color: "pink" }}>{item.icon}</Box>
                <Typography variant="h5" fontWeight="bold">
                  {item.label}
                </Typography>

                {item.pricing.map((plan, planIndex) => (
                  <Box key={planIndex} sx={{ marginBottom: 2, mt: 2 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedPlans[item.category].includes(
                            plan.plan
                          )}
                          onChange={() =>
                            handleCheckboxChange(item.category, plan.plan)
                          }
                          sx={{
                            color: "#42326e",
                            "&.Mui-checked": {
                              color: "#42326e",
                            },
                          }}
                        />
                      }
                      label={`${plan.plan}: ₹ ${plan.price}`}
                    />
                    <Typography variant="body2" color="textSecondary">
                      {plan.description}
                    </Typography>
                  </Box>
                ))}

                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    backgroundColor: "#42326e",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "black",
                      color: "white",
                    },
                  }}
                  onClick={() => handleSubscribe(item)}
                  disabled={selectedPlans[item.category].length === 0}
                >
                  Subscribe
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Opportunities;
